import React, { PropTypes } from 'react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { withRouter, routerShape } from 'react-router';
import ImmutablePropTypes from 'react-immutable-proptypes';
import cn from 'classnames';
import { getLabel } from '@bibliocommons/utils-filter';
import './ActiveFilters.scss';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { Button } from '@bibliocommons/base-buttons';
import getToggledFilter from '../../../helpers/facets/getToggledFilter';
import ActiveFilterLockSwitch from '../ActiveFilterLockSwitch';
import ActiveFilterToken from '../../shared/Facets/ActiveFilterToken';
import updateSearchQuery from '../../../helpers/search/updateSearchQuery';

export class ActiveFilters extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('renderActiveFilters', 'handleClearFilters', 'handleToggleFilter');
  }

  handleClearFilters() {
    const { searchType, location } = this.props;
    const query = updateSearchQuery({
      currentQuery: location.query,
      searchType,
      pagination_page: undefined
    });

    this.props.router.push({ ...location, query });
  }

  handleToggleFilter(fieldId, currentFilter) {
    const { activeFilters, location, searchType } = this.props;

    const query = updateSearchQuery({
      currentQuery: location.query,
      activeFilters,
      searchType,
      pagination_page: undefined,
      ...getToggledFilter(fieldId, currentFilter, activeFilters)
    });

    this.props.router.push({ ...location, query });
  }

  renderClearFilter() {
    if (!this.props.activeFilters.isEmpty()) {
      return (
        <Button
          className="cp-filter-token clear-token"
          handleClick={this.handleClearFilters}>
          <FormattedMessage id="clear_filters" />
        </Button>
      );
    }

    return null;
  }

  renderActiveFilters(fieldId, filter) {
    const normalizedId = fieldId === 'PRIMARY_LANGUAGE' ? 'LANGUAGE' : fieldId;
    const filterLabel = getLabel(this.props.intl, normalizedId, (filter.get('label') || filter.get('value')), this.props.singleBranch);

    return (
      <ActiveFilterToken
        handleToggleFilter={this.handleToggleFilter}
        filter={filter}
        fieldId={fieldId}
        filterLabel={filterLabel} />
    );
  }

  renderActiveFields() {
    return this.props.activeFilters.entrySeq().map(([fieldId, filters]) => filters ? filters.map(this.renderActiveFilters.bind(null, fieldId)) : null);
  }

  renderFilterControls() {
    const { activeFilters, searchType, locked, showLockSwitch } = this.props;

    return showLockSwitch && (
      <div className="filter-controls">
        <FormattedMessage id="Search.activeFilters">
          {
            (message) => (
              <span className="active-filter-label">
                {message}
              </span>
            )
          }
        </FormattedMessage>
        <ActiveFilterLockSwitch
          searchType={searchType}
          active={locked}
          activeFilters={activeFilters} />
      </div>
    );
  }

  render() {
    const activeFilterClass = cn('cp-active-filter', 'clearfix', this.props.locked ? 'active' : '');
    return (
      <div className={activeFilterClass}>
        {this.renderFilterControls()}
        <div className="filter-tokens">
          {this.renderActiveFields()}
          {this.renderClearFilter()}
        </div>

      </div>
    );
  }
}

ActiveFilters.propTypes = {
  activeFilters: ImmutablePropTypes.map,
  searchType: PropTypes.string,
  locked: PropTypes.bool,
  singleBranch: PropTypes.bool,
  intl: intlShape,
  router: routerShape,
  showLockSwitch: PropTypes.bool
};

ActiveFilters.defaultProps = {
  showLockSwitch: true
};

export default injectIntl(withRouter(ActiveFilters));



// WEBPACK FOOTER //
// ./app/components/search/ActiveFilters/ActiveFilters.jsx